import type { UseQueryOptions } from '@tanstack/react-query';

import { getRequest } from '../../services/api';
import { subscriptionQueryKeys } from '../../services/queryClient';
import type { ApiResponse } from '../../services/types';
import type { SubscriptionApiPayload } from '../../stores/subscription/types';
import { useStores } from '../../stores/useStores';

import { FIFTEEN_MINUTES, THIRTY_MINUTES } from './constants';
import { useQuery } from './useCustomQuery';
import { combineEnabled, extractEnabled } from './utils';

export const useSubscriptionData = (
  options?: Omit<UseQueryOptions<SubscriptionApiPayload>, 'queryKey' | 'queryFn'>,
) => {
  const { subscriptionStore } = useStores();
  const { enabled, restOptions } = extractEnabled(options);

  return useQuery({
    queryKey: subscriptionQueryKeys.data(),
    queryFn: async (): Promise<SubscriptionApiPayload> => {
      const response = await getRequest<ApiResponse<SubscriptionApiPayload>>('/v2/subscription/data');
      const subscriptionData = response.data.data;

      subscriptionStore.updateSubscriptionDataFromQuery(subscriptionData);

      return subscriptionData;
    },
    staleTime: FIFTEEN_MINUTES,
    gcTime: THIRTY_MINUTES,
    enabled: combineEnabled(subscriptionStore.subscriptionEnabled, enabled),
    ...restOptions,
  });
};
